import { render } from "./Rolmodal.vue?vue&type=template&id=01a634cb"
import script from "./Rolmodal.vue?vue&type=script&lang=js"
export * from "./Rolmodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__